import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTextToImage: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="text-to-image">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9H22V21H10V9ZM12 11V19H12.5858L18 13.5858L20 15.5858V11H12ZM20 18.4142L18 16.4142L15.4142 19H20V18.4142Z"
        fill="currentColor"
      />
      <path
        d="M15.5 13.25C15.5 13.9404 14.9404 14.5 14.25 14.5C13.5596 14.5 13 13.9404 13 13.25C13 12.5596 13.5596 12 14.25 12C14.9404 12 15.5 12.5596 15.5 13.25Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 3H11V6H9V5H7V12H8V14H4V12H5V5H3V6H1V3Z"
        fill="currentColor"
      />
      <path
        d="M19.5 2L18.6667 3.66667L17 4.5L18.6667 5.33333L19.5 7L20.3333 5.33333L22 4.5L20.3333 3.66667L19.5 2Z"
        fill="currentColor"
      />
      <path
        d="M15 4L14.3333 5.33333L13 6L14.3333 6.66667L15 8L15.6667 6.66667L17 6L15.6667 5.33333L15 4Z"
        fill="currentColor"
      />
      <path
        d="M4.5 17L3.66667 18.6667L2 19.5L3.66667 20.3333L4.5 22L5.33333 20.3333L7 19.5L5.33333 18.6667L4.5 17Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconTextToImage;
